import { useMemo } from "react";
import { API } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";

const APPLICATIONS_BASE = "/Applications";

const fetchApplicationsAPI = () => API.get(`${APPLICATIONS_BASE}`);

const addApplicationAPI = (data) =>
  API.post(`${APPLICATIONS_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateApplicationAPI = (id, data) =>
  API.patch(`${APPLICATIONS_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const applicationService = createApplicationService({
  name: "applicationsData",
  apiFetchFn: fetchApplicationsAPI,
  apiAddFn: addApplicationAPI,
  apiUpdateFn: updateApplicationAPI,
});

const applicationReducer = applicationService.reducer;
const getApplications = applicationService.getData;
const addApplication = applicationService.addData;
const updateApplication = applicationService.updateData;
const useApplications = applicationService.useData;

const getActiveApplications = async () => {
  const applications = await getApplications();
  return applications.filter((app) => app.active) || [];
};

const useActiveApplications = () => {
  const { data, loading } = useApplications();
  const activeApplications = useMemo(
    () => data.filter((app) => app.active),
    [data]
  );

  return { data: activeApplications, loading };
};

export {
  applicationReducer,
  getApplications,
  addApplication,
  updateApplication,
  useApplications,
  getActiveApplications,
  useActiveApplications,
};

